import React from "react";
import { Grid, Card, Image, Table, Popup } from "semantic-ui-react";
import Constants from "../util/Constants";
import Utils from "../util/Utils";

const GainersLosers = ({ gainersLosers, onClickSymbolFunction }) => {
  const renderStockTable = (list, isGainer) => {
    const safeList = Array.isArray(list) ? list : [];
    return (
      <Table celled compact="very" basic="very" unstackable>
        <Table.Body>
          {safeList.map((stock, index) => {
            if (
              !stock ||
              (isGainer && stock.changesPercentage <= 0) ||
              (!isGainer && stock.changesPercentage >= 0)
            ) {
              return null;
            }

            return (
              <Table.Row key={stock.symbol}>
                <Table.Cell>
                  <Popup
                    trigger={
                      <div
                        onClick={() => onClickSymbolFunction(stock.symbol)}
                        style={{
                          cursor: "pointer",
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        <Image
                          src={`${Constants.IMAGE_URL}${stock.symbol}.jpg`}
                          avatar
                          style={{ marginRight: "0.5em" }}
                        />
                        <span style={{ fontWeight: "bold" }}>
                          {stock.symbol}
                        </span>
                      </div>
                    }
                    content={
                      <>
                        <Popup.Header>{stock.name}</Popup.Header>
                        <Popup.Content>
                          <p>{Utils.format_currency_usd(stock.price)}</p>
                          <p>
                            {Utils.format_currency_usd(stock.change)} (
                            {stock.changesPercentage}%)
                          </p>
                        </Popup.Content>
                      </>
                    }
                  />
                </Table.Cell>
                <Table.Cell textAlign="right">
                  <span
                    style={{
                      color: isGainer ? "#4caf50" : "#f44336",
                      fontWeight: "bold",
                    }}
                  >
                    {Utils.format_number(stock.changesPercentage)}%
                  </span>
                </Table.Cell>
              </Table.Row>
            );
          })}
        </Table.Body>
      </Table>
    );
  };

  const renderCategory = (name, list, isGainer) => (
    <Card style={{ minHeight: "200px", height: "270px", overflowY: "auto", overflowX: "visible" }} className="gainer-loser-card">
      <Card.Header
        textAlign="center"
        style={{
          height: "40px",
          background: isGainer ? "#66bb6a" : "#e57373",
          color: "white",
          padding: "0.5em",
          fontSize: "14px",
        }}
      >
        {name}
      </Card.Header>
      <Card.Content style={{ padding: "0.5em" }}>
        {renderStockTable(list, isGainer)}
      </Card.Content>
    </Card>
  );

  const renderCategoryGroup = (gainersCategories, losersCategories) => (
    <Grid.Row style={{ padding: "0.5em 0" }}>
      {(gainersCategories || []).map(({ name, list }) => (
        <Grid.Column
          key={name}
          mobile={8}
          tablet={8}
          computer={2}
          style={{ padding: "0.2em" }}
        >
          {renderCategory(name, list, true)}
        </Grid.Column>
      ))}

      {(losersCategories || []).map(({ name, list }) => (
        <Grid.Column
          key={name}
          mobile={8}
          tablet={8}
          computer={2}
          style={{ padding: "0.2em" }}
        >
          {renderCategory(name, list, false)}
        </Grid.Column>
      ))}
    </Grid.Row>
  );

  const safeGainersLosers =
    gainersLosers && typeof gainersLosers === "object" && !Array.isArray(gainersLosers)
      ? gainersLosers
      : {};
  const gainersCategories = [
    { name: "Dow  Gainers", list: safeGainersLosers.dowGainers },
    { name: "S&P  Gainers", list: safeGainersLosers.spGainers },
    { name: "NASDAQ  Gainers", list: safeGainersLosers.nasdaqGainers },
    { name: "Russell  Gainers", list: safeGainersLosers.russellGainers },
  ];

  const losersCategories = [
    { name: "Dow  Losers", list: safeGainersLosers.dowLosers },
    { name: "S&P  Losers", list: safeGainersLosers.spLosers },
    { name: "NASDAQ  Losers", list: safeGainersLosers.nasdaqLosers },
    { name: "Russell  Losers", list: safeGainersLosers.russellLosers },
  ];

  return (
    <Grid style={{ padding: "0.4em 0", margin: 0, width: "100%" }}>
      {renderCategoryGroup(gainersCategories, losersCategories)}
    </Grid>
  );
};

export default GainersLosers;
